import { render, staticRenderFns } from "./homeCseg.vue?vue&type=template&id=2e783622&scoped=true"
import script from "./homeCseg.vue?vue&type=script&lang=js"
export * from "./homeCseg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e783622",
  null
  
)

export default component.exports